/**
 * FrontpageHero section
 */
(function frontpageHeroFrontend($) {
	$(document).on('cms.ready', ready);

	// TODO: Does not work properly if added "fresh" on page

	let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

	/* Initial building of the ServiceCases */
	function ready() {
		logged_in = $('body.logged-in').length;

		// let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		// console.log('isSafari', isSafari);
		// if (false && isSafari) {
		// 	// alert('YOU ARE ON SAFARI');
		// 	return;
		// }


		if(logged_in) {
			// Set up intersect listener on document since that's the only way we can listen to newly added elements
			$(document).on('cms.intersect', '.sectionFrontpageHero', function intersect(evt, entry, $elm) {
				setupSection(0, $elm);
			});
		}

		$('.sectionFrontpageHero').each(setupSection);
	}

	function setupSection(i, elm) {
		let $elm = $(elm),
			$wave = $elm.find('.frontpage-hero__waves img');

		if($wave.data('anim')) {
			$wave.attr('src', $wave.data('anim'));
		}
	}
})(jQuery);